module.exports = __webpack_public_path__ + "img/info_10.7b77fe52.png";